module.exports = __webpack_public_path__ + "img/46_22.006efbdb.png";